import { MatchedDriveWaypointCollection } from './_matched_drive_waypoint_collection';
export class Drive {
    constructor(attributes) {
        // scope helepr - use _drive instead of this to access this object
        // in closures.
        var _drive = this;
        // The attributes of the Drive model from the serer
        this.attributes = attributes;
        // A MatchedDriveWaypointsCollection instance
        this.matchedDriveWaypoints;
        // The Leaflet layers displaying waypoints as dots (not lines)
        this.dots = [];
        // The leaflet Layer of the car icon showing the current front of the drive
        this.carLayer = undefined;
        // The Leaflet.motion control showing the route itself.
        this.polyline = undefined;

        this.log = function () {
            var args = Array.prototype.slice.call(arguments);
            if (args[0] == 'error') {
                args.shift(); // Remove the 'error' bit.
                args[0] = `Drive ${_drive.attributes.id} ` + args[0];
                return console.error.apply(console, args);
            }
            args[0] = `Drive ${_drive.attributes.id} ` + args[0];
            console.log.apply(console, args);
        }
        this.remove = function () {
            _drive.log(`Removing itself`);
            _drive.removeFromMap();
        };

        /**
         * Grab the drive waypoints and put them on the map
        **/
        this.show = function () {
            // Remove any existing layers
            _drive.removeFromMap();
            this.matchedDriveWaypoints = new MatchedDriveWaypointCollection();

            if (DASHBOARD_TRACKING_SWITCHER.showLines) {
                _drive.log('drawing a line');
                this.getExistingWaypoints('lines').then(function (response) {
                    let matchedDriveWaypoints = response.data.data;
                    _drive.log(`Has ${matchedDriveWaypoints.length} initial waypoints`);
                    _drive.drawNewWaypoints(matchedDriveWaypoints);
                });
            }
            if (DASHBOARD_TRACKING_SWITCHER.showDots) {
                _drive.log('getting dots to draw');
                // Get all the already saved waypoints in one big bulk (no need to stream them);
                this.getExistingWaypoints('dots').then(function (response) {
                    _drive._drawDots(response.data.data);
                });
            }
        }

        this.setReplayDuration = function (duration) {
            if (_drive.polyline && _drive.polyline.motionDuration) {
                _drive.polyline.motionDuration(duration);
            }
            return _drive;
        };

        this.getExistingWaypoints = function (context) {
            return axios.get(
                route('drive.get-drive-waypoints', {
                    drive: _drive.attributes.id,
                    context: context
                })
            );
        }

        /**
         * Given a list of DriveWaypoints draw them all as dots on the map
         */
        this._drawDots = function (driveWaypoints) {
            _drive.log(`Drawing Dots ${driveWaypoints.length} dots`);
            if (_drive.dots !== undefined && _drive.dots.remove) {
                _drive.dots.remove();
            }
            _drive.dots = L.layerGroup().addTo(window.DASHBOARD_MAP.map);
            $.each(driveWaypoints, function (item, driveWaypoint) {
                var status = DASHBOARD_DRIVES.getDriveWaypointStatusInfo(driveWaypoint.status);
                var marker = new L.marker(
                    new L.latLng(driveWaypoint.lat, driveWaypoint.lng),
                    {
                        icon: status.icon
                    }
                );
                marker.bindPopup(`${driveWaypoint.id}: ${status.name}`);
                // Save the dot reference so we can remove it later.
                _drive.dots.addLayer(marker);
            });
        }

        // Draw the given waypoints on the map
        this.drawNewWaypoints = function (driveWaypoints) {
            _drive.log(`has ${driveWaypoints.length} new waypoints to draw`);
            if (driveWaypoints.length < 1) {
                return;
            }
            _drive.polyline = L.motion.polyline(
                driveWaypoints,
                { // Options:
                    color: "#ff0000",
                    opacity: .3,
                    weight: 6,
                }, // Motion Options:
                {
                    duration: 100,
                }, { // Marker Options:
                icon: L.icon({
                    iconUrl: '/images/car.png',
                    iconSize: [40, 20],
                    iconAnchor: [20, 10],
                }),
            });
            _drive.polyline.addTo(window.DASHBOARD_MAP.map);
            _drive.polyline.motionStart();
            return;
        }
        // Remove waypoints from the map
        this.removeFromMap = function () {
            _drive.removeLineFromMap();
            _drive.removeDotsFromMap();
        }

        this.removeLineFromMap = function () {
            if (_drive.polyline !== undefined) {
                _drive.log(`is removing it's line fom the map`);
                window.DASHBOARD_MAP.map.removeControl(_drive.polyline);
                _drive.polyline = undefined;
            }
        }

        this.removeDotsFromMap = function () {
            if (_drive.dots !== undefined && _drive.dots.remove) {
                _drive.log(`is removing it's dots fom the map`);
                _drive.dots.remove();
                _drive.dots = undefined;
            }
        }

        this.startReply = function () {
            this.polyline.motionStart();
            return this;
        }
        this.stopReplay = function(){
            this.polyline.motionStop();
            return this;
        }
        this.setReplayDuration = function(miliseconds){
            this.polyline.motionDuration(miliseconds);
            return this;
        }

        _drive.log(`Created`);
        _drive.show();
        window.onbeforeunload = function () {
            _drive.remove();
        }
    }
}
